import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { AnimatedViews } from '@garnish/core';

import { NotificationPreferencesContent } from '../NotificationPreferencesContent';
import {
  NotificationPreferencesControlsContainer,
  NotificationPreferencesControlSection,
} from '../NotificationPreferencesControl';

// ─────────────────────────────────────────────────────────────────────────────

export const NotificationPreferencesSkeleton = (props: Props) => {
  const { index = 0 } = props;

  return (
    <NotificationPreferencesContent>
      <AnimatedViews.Pulse index={index}>
        <View style={styles.title} />

        <View style={styles.subtitle} />

        <NotificationPreferencesControlsContainer>
          <NotificationPreferencesControlSection>
            <View style={styles.pushOptionLabel} />

            <View style={styles.toggle} />
          </NotificationPreferencesControlSection>

          <NotificationPreferencesControlSection>
            <View style={styles.emailOptionLabel} />

            <View style={styles.toggle} />
          </NotificationPreferencesControlSection>
        </NotificationPreferencesControlsContainer>
      </AnimatedViews.Pulse>
    </NotificationPreferencesContent>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    width: '32%',
    height: 14,
    marginTop: 4,
    marginBottom: theme.spacing['2'],
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  subtitle: {
    width: '72%',
    height: 14,
    marginVertical: 4,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  pushOptionLabel: {
    width: 128,
    height: 12,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  emailOptionLabel: {
    width: 48,
    height: 12,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  toggle: {
    width: 56,
    height: 32,
    borderRadius: theme.radius['3xLarge'],
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  index?: number;
};
